import * as React from "react";
import PropTypes from 'prop-types';

const SvgChevron2022 = props => {
  if (props.id !== "_svgchevron2022") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13.438 30.559a1.495 1.495 0 002.113 2.114l11.534-11.534c.191-.191.32-.42.386-.664.163-.552-.005-1.214-.486-1.695L15.751 7.546c-.666-.666-1.681-.732-2.266-.146-.586.585-.52 1.6.146 2.266l10.35 10.35-10.543 10.543zm.193-20.893l1.06-1.06-1.06 1.06zm1.06-1.06l1.06-1.06-1.06 1.06z" fill="#202020" /></svg>;
};

SvgChevron2022.displayName = "_svgchevron2022";
SvgChevron2022.propTypes = {
  id: PropTypes.string
};
SvgChevron2022.defaultProps = {
  id: ''
};
export default SvgChevron2022;